import { Box, Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import React, { useState } from "react";
import { IFormEvent } from "../form/Form.interface";
import { Status } from "../common/config";
import FormText from "../form/FormText";
import FormTags from "../form/FormTags";
import Util from "../services/util";
import FormBody from "../form/FormBody";
import DisplayBody from "../ui/DisplayBody";
import FormSwitch from "../form/FormSwitch";
import axios from "axios";
import { snk } from "../services/app.service";
import moment from "moment";
import FormSelect from "../form/FormSelect";
import FormDate from "../form/FormDate";
import { format } from "date-fns";

export default function NewsForm(props: { form: any, onClose: (event: any) => void }) {
  const _form = props.form;
  _form.body = _form.body.length === 0 ? Util.textTobody(_form.text) : _form.body;
  const [channelOption, setChannelOption] = React.useState<any>([])

  const [form, setForm] = useState<any>(_form)
  const [preview, setPreview] = useState<boolean>()
  const [audit, setAudit] = useState<boolean>()

  function handelFormChange(e: IFormEvent): void {
    setForm(Util.formChange(e, form))
  }

  React.useEffect(() => {
    axios.post('cms/channelsIndex', {}).then(({ data }) => {
      setChannelOption(data)
    })
  }, [])

  function handleStatus(status: number) {
    const { title, body, tags, source, _id, pubDate: _pubDate,channel } = form
    const pubDate = format(new Date(_pubDate), 'yyyy-MM-dd HH:mm:ss')
    axios.post('cms/saveAudit', { _id, title, body, status, tags, source, pubDate, channel }).then(({ data }) => {
      if (data.modifiedCount === 1 || data._id) {
        props.onClose(true)
      } else {
        snk.next({ msg: '保存失败' })
      }
    })
  }

  return <React.Fragment>
    <Dialog open onClose={props.onClose}>
      <DialogTitle>{form.title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Stack spacing={2} direction="row">
            <Typography variant="caption">{form.channel}</Typography>
            <Typography variant="caption">ID:{form._id}</Typography>
            <Typography variant="caption">发布时间:{form.pubDate}</Typography>
          </Stack>
          <FormText label="标题" name="title" value={form.title} onChange={handelFormChange} />
          <FormSelect label="频道" name="channel" value={form.channel} onChange={handelFormChange}
            options={channelOption} />
          <FormTags name={"tags"} value={form.tags} label={"标签"} onChange={handelFormChange} />
          <FormText label="来源" name="source" value={form.source} onChange={handelFormChange} />
          {/* <FormText label="发布时间" name="pubDate" value={form.pubDate} onChange={handelFormChange} /> */}
          <FormDate name={"pubDate"} time value={form.pubDate} label={"发布时间"} onChange={handelFormChange}></FormDate>
          <Stack direction={'row'}>
            <Typography variant="caption" flexGrow={1}>正文</Typography>
            <FormSwitch name={""} value={preview} label={"编辑"} onChange={() => {
              setPreview(!preview)
            }} />
          </Stack>
          {preview ?
            <FormBody value={form.body}
              onChange={(e) => {
                form.body = e
                setForm({ ...form })
              }} />
            : <Box sx={{ img: { maxWidth: '100%', margin: 0, ml: '-2rem' } }}>
              <DisplayBody body={form.body} />
            </Box>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack flexGrow={1}>
          <Button onClick={() => { setAudit(true) }}>审核状态：{Status.newsAudit[form._audit.status]}</Button>
        </Stack>
        <ButtonGroup >
          <Button disabled={form._audit.status === 2} onClick={() => { handleStatus(2) }}>已审</Button>
          <Button disabled={form._audit.status === 1} onClick={() => { handleStatus(1) }}>删除</Button>
          <Button disabled={form._audit.status === 3} onClick={() => { handleStatus(3) }}>发布</Button>
          <Button onClick={() => { handleStatus(form._audit.status) }}>保存</Button>
        </ButtonGroup>
      </DialogActions>
    </Dialog>
    <Dialog open={!!audit} onClose={() => setAudit(false)}>
      <DialogTitle>当前状态:{Status.newsAudit[form._audit.status]}</DialogTitle>
      <DialogContent  >
        {!form._audit.description.length ? <Stack>
          没有审核记录
        </Stack> : <Table>
          <TableHead>
            <TableRow>
              <TableCell>姓名</TableCell>
              <TableCell>电话</TableCell>
              <TableCell>状态</TableCell>
              <TableCell>时间</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...form._audit.description].reverse().map((i: any, index: number) => <TableRow key={index}>
              <TableCell>{i.name}</TableCell>
              <TableCell>{i.mobile}</TableCell>
              <TableCell>{Status.newsAudit[i.status]}</TableCell>
              <TableCell>{moment(i.at).format('yyyy/MM/DD HH:ss')}</TableCell>
            </TableRow>)}
          </TableBody>
        </Table>}
      </DialogContent>
    </Dialog>
  </React.Fragment>
}